import { render, staticRenderFns } from "./device-on-off-install2.vue?vue&type=template&id=7415296a&scoped=true&"
import script from "./device-on-off-install2.js?vue&type=script&lang=js&"
export * from "./device-on-off-install2.js?vue&type=script&lang=js&"
import style0 from "./device-on-off-install2.css?vue&type=style&index=0&id=7415296a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7415296a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText})
